import detectEthereumProvider from "@metamask/detect-provider";
import Web3 from "web3";

export default {
  data() {
    return {
      provider: null,
      chainId: null,
      accountAddress: null,
      web3: null,
      mmInstalled: false,
      isMetaMask: false,
      isTrustWallet: false,
      useOnlyMetaMask: false,
      statusConnection: false,
      statusChange: false,
      isMobile: false,
      isWalletConnect: false,
      walletConnectProvider: null
    };
  },
  methods: {
    detectMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      return this.isMobile;
    },

    async connectWalletConnect() {
      try {
        // Открываем глубокую ссылку MetaMask для мобильных
        const dappUrl = window.location.hostname;
        const metamaskDeepLink = `https://metamask.app.link/dapp/${dappUrl}`;

        // Показываем пользователю ссылку или открываем в новом окне
        window.open(metamaskDeepLink, "_blank");

        // Альтернативно можно показать QR-код для WalletConnect
        this.$toast.info("Откройте MetaMask на вашем телефоне или отсканируйте QR-код");
      }
      catch (error) {
        console.error("Mobile connection error:", error);
        this.$toast.error("Ошибка подключения на мобильном устройстве");
      }
    },

    async startWallet(paramProvider = null) {
      this.detectMobile();

      if (this.isMobile && !window.ethereum) {
        await this.connectWalletConnect();
        return;
      }

      if (window.ethereum) {
        const provider = paramProvider ? paramProvider : await detectEthereumProvider();

        this.isMetaMask = provider?.isMetaMask || false;
        this.isTrustWallet = provider?.isTrustWallet || false;

        if (this.isTrustWallet && this.isMetaMask) {
          this.useOnlyMetaMask = true;
        }

        if (provider) {
          // If the provider returned by detectEthereumProvider is not the same as
          // window.ethereum, something is overwriting it, perhaps another wallet.
          this.provider = provider;
          this.chainId = await provider.request({ method: "eth_chainId" }); // 0x61

          provider
            .request({ method: "eth_accounts" })
            .then(this.metamaskEventAccountsChanged.bind(this))
            .catch((err) => {
              // Some unexpected error.
              // For backwards compatibility reasons, if no accounts are available,
              // eth_accounts will return an empty array.
              console.error(err);
            });

          provider.on("accountsChanged", this.handleAccountsChanged.bind(this));
          provider.on("connect", this.metamaskEventConnected.bind(this));
          provider.on("disconnect", this.metamaskEventDisconnected.bind(this));
          provider.on(
            "accountsChanged",
            this.metamaskEventAccountsChanged.bind(this)
          );
          provider.on("chainChanged", this.metamaskEventChainChanged.bind(this));
          provider.on("message", this.metamaskEventMessage.bind(this));

          this.mmInstalled = true;
          this.$store.dispatch("mmInstalled", true);
          this.web3 = new Web3(provider);
        }
      }
    },
    metamaskEventAccountsChanged(accounts) {
      if (accounts.length > 0) {
        this.accountAddress = accounts[0];
        this.$store.dispatch("accountAddress", accounts[0]);
      }
    },
    metamaskEventConnected(connectInfo) {
      console.log("metamaskEventConnected");
      console.log(connectInfo);
      // TODO ...
    },
    metamaskEventDisconnected(providerRpcError) {
      console.log("metamaskEventDisconnected");
      console.log(providerRpcError);
    },
    handleAccountsChanged(providerRpcError) {
      if (providerRpcError[0]) {
        this.accountAddress = providerRpcError[0];
        this.$store.dispatch("accountAddress", providerRpcError[0]);
      }
      else {
        this.accountAddress = null;
        this.$store.dispatch("accountAddress", null);
      }
    },
    metamaskEventChainChanged(chainId) {
      console.log("metamaskEventChainChanged");
      console.log(chainId);
      if (chainId !== this.chainId) {
        // TODO this.$store.commit('wallet/setV2ChainId', chainId)
        this.chainId = chainId;
      }
    },
    metamaskEventMessage(msg) {
      console.log("metamaskEventMessage");
      console.log(msg);
      // TODO ...
    },
    // Принудительное подключение
    connectMetamaskAction() {
      if (this.isMobile && !window.ethereum) {
        return this.connectWalletConnect();
      }

      return new Promise((resolve, reject) => {
        this.statusConnection = true;
        const ethereum = this.provider;
        ethereum
          .request({ method: "eth_requestAccounts" })
          .then(() => {
            this.statusConnection = false;
            this.metamaskEventAccountsChanged.bind(this);
            resolve(true); // Успешное подключение
          })
          .catch((err) => {
            this.statusConnection = false;
            if (err.code === 4001) {
              // EIP-1193 userRejectedRequest error
              console.log("Please connect to MetaMask.");
              reject(err?.code);
            }
            else {
              this.statusConnection = true;
              console.error(err);
              this.$toast.error(
                this.$t("metaMask.metaMaskPassword"),
                {
                  timeout: 8000
                }
              );
              reject(err?.code); // если кошелек уже открыт
            }
          });
      });
    },
    // Принудительное открытие
    openMetamaskAction() {
      this.statusChange = true;
      const ethereum = this.provider;
      ethereum
        .request({
          method: "wallet_requestPermissions",
          "params": [
            {
              "eth_accounts": {}
            }
          ]
        })
        .then(() => {
          this.statusChange = false;
        })
        .catch((err) => {
          this.statusChange = false;
          if (err.code === 4001) {
            // EIP-1193 userRejectedRequest error
            // If this happens, the user rejected the connection request.
            console.log("Please connect to MetaMask.");
          }
          else {
            this.statusChange = true;
            console.error(err);
          }
        });
    },
    // https://eips.ethereum.org/EIPS/eip-3085
    metamaskAddEthereumChain(chain) {
      const ethereum = this.provider;
      ethereum
        .request({
          method: "wallet_addEthereumChain",
          params: [chain]
        })
        .catch(() => {
          console.error("Net add error");
        });
    },
    async metamaskCheckAndSwitch(chain) {
      await this.connectMetamaskAction();
      const chainId = await this.provider.request({ method: "eth_chainId" });
      if (chainId === chain.chainId) {
        return;
      }
      await this.provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chain.chainId }]
      })
        .catch(async err => {
          if (err.code === 4902) {
            await this.metamaskAddEthereumChain(chain);
          }
          else {
            console.error("Net switch error");
          }
        });
      this.chainId = chain.chainId;
    },
    // https://eips.ethereum.org/EIPS/eip-747
    metamaskAddEthereumCoin(token) {
      const ethereum = this.provider;
      ethereum
        .request({
          method: "wallet_watchAsset",
          params: {
            type: "ERC20",
            options: {
              address: token.createdAddress,
              symbol: token.mnemonicEng,
              decimals: token.decimals ? token.decimals : 0,
              image: token.logoMain ? token.logoMain : ""
            }
          }
        })
        .then(() => {
          this.$toast.success(this.$t("metaMask.tokenAdd"));
        })
        .catch(() => {
          this.$toast.error(this.$t("metaMask.tokenError"));
        });
    },

    async sendToken(token, addressTo, amount, fromAddress, chain) {
      if (chain) {
        await this.metamaskCheckAndSwitch(chain);
      }
      let abi = [{
        "inputs": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "transfer",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      }];

      let amountBN = this.web3.utils.toBN(amount);
      // let decimalsBN = this.web3.utils.toBN(token.decimals);

      const contract = new this.web3.eth.Contract(abi, token.createdAddress);
      // let value = amountBN.mul(this.web3.utils.toBN(10).pow(decimalsBN));
      await contract.methods.transfer(addressTo, amountBN).send({ from: fromAddress });
    }
  }
};
